import React from 'react'
import LabeledValue from '../../../../components/common/LabeledValue'
import { HistoryEvent } from '../../../../store/slices/Requestor/timeOffDetailsSlice'

interface HistorySectionProps {
  history: HistoryEvent[]
}

const HistorySection: React.FC<HistorySectionProps> = ({ history }) => {
  if (!history || history.length === 0) return null
  return (
    <div className="w-full mt-6">
      <h2 className="h2 mb-10!">History</h2>
      <div className="space-y-4 mt-4">
        {history.map((event, idx) => (
          <div
            key={`${event.statusCode ?? event.event}-${event.date}-${idx}`}
            className="mb-10!"
          >
            <div className="space-y-1">
              <LabeledValue
                label={event.dateLabel ?? 'Date'}
                value={event.date}
              />
                 {event.approvedTimeOffRequestId && (
                <LabeledValue
                  label={
                    event.approvedTimeOffRequestIdLabel ??
                    'Approved time off request id'
                  }
                  value={event.approvedTimeOffRequestId}
                />
              )}
                {event.deniedTimeOffRequestId && (
                <LabeledValue
                  label={
                    event.deniedTimeOffRequestIdLabel ??
                    'Denied Time Off Request Id'
                  }
                  value={event.deniedTimeOffRequestId}
                />
              )}
              {event.by && (
                <LabeledValue label={event.byLabel ?? 'By'} value={event.by} />
              )}

              <LabeledValue
                label={event.commentsLabel ?? 'Comments'}
                value={event.comments || '-'}
              />
              {event.highlightMessage && (
                <div className="highlight-message">
                  <b>{event.highlightMessage}</b>
                </div>
              )}
              {event.denialReason && (
                <LabeledValue
                  label={event.denialReasonLabel ?? 'Denial Reason'}
                  value={event.denialReason}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default HistorySection

